export const SET_PASTAS = 'SET_PASTAS';
export const LOADING_PASTAS = 'LOADING_PASTAS';
export const PASTAS_PAGE = 'PASTAS_PAGE';
export const PASTAS_PERPAGE = 'PASTAS_PERPAGE';
export const PASTAS_TOTAL = 'PASTAS_TOTAL';
export const SET_CATEGORIA_DISPONIVEL = 'SET_CATEGORIA_DISPONIVEL';
export const PASTA_SELECT_EMPLOYEE = 'PASTA_SELECT_EMPLOYEE';
export const SET_PASTA_FUNCIONARIO = 'SET_PASTA_FUNCIONARIO';